module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 10-51-46-553.7685686c.mp4";